import classNames from 'classnames';

import { ContainerProps } from './container.types';

const useContainerService = ({
  safeArea,
  className,
}: Partial<ContainerProps>) => {
  const isSafeObject = typeof safeArea === 'object';

  const cssClasses = classNames('container-wrapper', className, {
    'safe-all': safeArea === true,
    'safe-top': isSafeObject && safeArea?.top === true,
    'safe-left': isSafeObject && safeArea?.left === true,
    'safe-right': isSafeObject && safeArea?.right === true,
    'safe-bottom': isSafeObject && safeArea?.bottom === true,
  });

  return { cssClasses };
};

export default useContainerService;
